import React from 'react'
import { Checkbox } from '@scentregroup/ui'
import trackEvent from '../../helpers/analytics-utils/track-event'
import { categories, actions } from '../../helpers/analytics-utils/constants'
import styles from './index.module.scss'

export interface WhatsHappeningMultiFilterProps {
  filterOptions: string[]
  selectedOptions: string[]
  onSelectionChange: (selectedOptions: string[]) => void
}

const WhatsHappeningMultiFilter = ({
  filterOptions,
  selectedOptions,
  onSelectionChange,
}: WhatsHappeningMultiFilterProps): JSX.Element | null => {
  if (!filterOptions || filterOptions.length === 0) {
    return null
  }
  const toggle = (isChecked: boolean, option: string): void => {
    trackEvent(
      categories.WHATS_HAPPENING_FILTERS,
      isChecked ? actions.FILTER_SELECT : actions.FILTER_DESELECT,
      option
    )
    const newSelectedOptions = isChecked
      ? [...selectedOptions, option]
      : selectedOptions.filter(opt => opt !== option)
    onSelectionChange(newSelectedOptions)
  }
  return (
    <div className={styles.multiFilters}>
      {filterOptions.map(option => (
        <Checkbox
          key={option}
          label={option}
          checked={selectedOptions.includes(option)}
          dataTestId={`checkbox-${option}`}
          onChange={(isChecked: boolean) => toggle(isChecked, option)}
        >
          {option}
        </Checkbox>
      ))}
    </div>
  )
}

export default WhatsHappeningMultiFilter
